module.exports = __webpack_public_path__ + "static/media/06.94f564cc.jpg";